<div class="lua-tuile" [ngClass]="{ disabled: disabled }">
  <lua-badge [number]="badgeCount">
    <div class="icon-container">
      <lua-icone
				*ngIf="!isIcon"
        [mode]="'outlined'"
        [fontSize]="'30px'"
        [iconName]="iconName"
      ></lua-icone>
			<lua-icone
				*ngIf="isIcon"
        [mode]="'outlined'"
        [fontSize]="'30px'"
        [customIconName]="iconName"
				[isIcon]="isIcon"
				height="30px" 
				width="30px"	
      ></lua-icone>
    </div>
    <div class="label">{{ label }}</div>
  </lua-badge>
</div>
